/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from './dialogContentLoading.styles';

type DialogContentLoadingProps = {
  title?: string;
  message?: string;
};

const DialogContentLoading: React.FunctionComponent<DialogContentLoadingProps> = ({
  title,
  message,
}) => {
  const classes = useStyles();

  return (
    <>
      {title && (
        <Typography className={classes.title} variant='h6'>
          {title}
        </Typography>
      )}
      {message && (
        <Typography className={classes.message} variant='body1'>
          {message}
        </Typography>
      )}
      <Grid
        alignItems='center'
        className={classes.containerLoading}
        container
        direction='row'
        justifyContent='center'
        spacing={2}>
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    </>
  );
};

export default DialogContentLoading;
export { DialogContentLoading };
